import Navbar from './pages/navbar/Navbar';
import Header from './pages/Header/Header';
import About from './pages/about/About';
import Speakers from './pages/speakers/Speakers';
import Works from './pages/works/Works';
import FAQs from './pages/faqs/FAQs';
import Contact from './pages/contact/Contact';
import Footer from './pages/footer/Footer';
import FloatingNav from './pages/floating-nav/FloatingNav';
import whatsap from './pages/contact/whatsap';
// import {Navbar, Header, About, Speakers, FAQs,Contact, Footer, FloatingNav} from './pages/index'
const App = () => {
  return (
    <main>
    <Navbar/>
    <Header/>
    <About/>
    <Speakers/>
    <Works/>
    {/* <FAQs/> */}
    <Contact/>
    <Footer/>

    {/* <FloatingNav/> */}
    
 </main>
  )
}

export default App